// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 974) return "scripts/974.js";
	if (chunkId === 855) return "scripts/855.js";
	if (chunkId === 993) return "scripts/993.js";
	if (chunkId === 483) return "scripts/483.js";
	// return url for filenames based on template
	return undefined;
};